import { Button } from "@braintrust/braintrust-ui-components";
import { RouterLink } from "@js/components/link";
import { pluralize as pluralizeUtil } from "@js/utils";

export type OpenProfileCompletionSequenceButtonProps = {
  name?: string;
  pluralize?: boolean;
  number: number | null;
};

export const OpenProfileCompletionSequenceButton = ({
  name,
  pluralize,
  number,
}: OpenProfileCompletionSequenceButtonProps) => {
  return (
    <Button
      variant="transparent"
      disableRipple
      RouterLink={RouterLink}
      href="/complete_profile"
      style={{
        fontSize: "11px",
        lineHeight: "26px",
        fontFamily: "inherit",
        color: "inherit",
        fontWeight: "inherit",
        textDecoration: "underline",
        height: "100%",
        verticalAlign: "baseline",
        padding: 0,
        minWidth: 0,
      }}
    >
      <>
        {name}
        {pluralize && number && pluralizeUtil(number)}
      </>
    </Button>
  );
};
